import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

/**
 * This reducer handles the LOAD_PROPERTY_MASTER_DATA_SUCCESS, LOAD_PROPERTY_MASTER_DATA_FAILURE,
 * and CLEAR_PROPERTY_MASTER_DATA actions and sets the property management data to the store
 * @param {Object} [state] The master data management property grid data
 * @param {Object} action The action to be handled
 * @returns {Object} The master data management property grid data
 */

export default function masterDataManagementPropertyReducers(
  state = initialState.propertyMasterData,
  action
) {
  if (
    action.type === actions.LOAD_PROPERTY_MASTER_DATA_SUCCESS &&
    Array.isArray(action.propertyMasterData)
  ) {
    return action.propertyMasterData;
  } else if (action.type === actions.LOAD_PROPERTY_MASTER_DATA_FAILURE) {
    return initialState.propertyMasterData;
  } else if (action.type === actions.CLEAR_PROPERTY_MASTER_DATA) {
    return initialState.propertyMasterData;
  } else {
    return state;
  }
}
